import React from 'react';
import './TimeHeatmap.css'; // We will create this CSS file next

const TimeHeatmap = ({ data, isLoading }) => {
    if (isLoading) {
        return <div>히트맵 데이터 로딩 중...</div>;
    }

    if (!data || data.length === 0) {
        return <div>표시할 히트맵 데이터가 없습니다.</div>;
    }

    // Define business hours and days of the week
    const hours = Array.from({ length: 13 }, (_, i) => i + 8); // 08:00 to 20:00
    const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    // Create a map for quick lookup
    const dataMap = new Map(data.map(item => [`${item.day}-${item.hour}`, item.count]));

    // Find max count for color scaling
    const maxCount = Math.max(...data.map(item => item.count), 0);

    const getOpacity = (count) => {
        if (maxCount === 0 || !count) return 0.1;
        return Math.max(0.1, count / maxCount);
    };

    return (
        <div className="heatmap-container">
            <div className="heatmap-grid">
                {/* Y-axis labels (hours) */}
                <div className="y-axis-labels">
                    {hours.map(hour => (
                        <div key={hour} className="axis-label">{`${String(hour).padStart(2, '0')}:00`}</div>
                    ))}
                </div>

                <div className="grid-content">
                    {/* X-axis labels (days) */}
                    <div className="x-axis-labels">
                        {days.map(day => (
                            <div key={day} className="axis-label">{day}</div>
                        ))}
                    </div>

                    {/* Grid cells */}
                    <div className="cells">
                        {days.map(day => (
                            <div key={day} className="day-column">
                                {hours.map(hour => {
                                    const count = dataMap.get(`${day}-${hour}`) || 0;
                                    const opacity = getOpacity(count);
                                    return (
                                        <div
                                            key={hour}
                                            className="cell"
                                            style={{ backgroundColor: `rgba(33, 150, 243, ${opacity})` }}
                                            title={`${day} ${hour}:00 - ${count}대`}
                                        >
                                            <span className="cell-count">{count > 0 ? count : ''}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimeHeatmap;
